import { Component } from '@angular/core';

@Component({
    selector: 'app-access-denied',
    styleUrls: ['./access-denied.component.scss'],
    template: `
    <div class="app-card rounded p-4 font-semibold">
      <div class="text-xl pb-4">Access Denied</div>
      <div>
        You don't have access to Resource Router. Please contact your supervisor.
      </div>
    </div>
  `,
    standalone: false
})
export class AccessDeniedComponent {}
